import { Box, Stack, Tooltip } from '@mui/material';
import React from 'react';
import Avatar from 'react-avatar';

export interface CreatorImageProps {
  imageURL?: string;
  logoURL?: string;
  firstName: string;
  lastName: string;
}

export interface ObjectCardCreatorImagesProps {
  creatorImages: CreatorImageProps[];
  createdByText?: string;
  coCreatedByText?: string;
}

export const ObjectCardCreatorImages: React.FC<ObjectCardCreatorImagesProps> = ({
  creatorImages,
  createdByText = '',
  coCreatedByText = '',
}) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      width="100%"
      style={{
        display: 'flex',
      }}
    >
      {creatorImages.map((creatorImage: CreatorImageProps, index: number) => (
        <Tooltip
          title={
            (index !== 0 && coCreatedByText ? coCreatedByText : createdByText) +
            (createdByText || coCreatedByText ? ' ' : '') +
            creatorImage.firstName +
            ' ' +
            creatorImage.lastName
          }
          arrow
          placement="top"
          key={'objectcardcreatorimage' + index}
        >
          {creatorImage.logoURL ? (
            <img
              width="25"
              height="25"
              style={{
                objectFit: 'contain',
                marginRight: '2px',
                aspectRatio: '1/1',
                borderRadius: '2px',
              }}
              src={creatorImage.logoURL}
            />
          ) : (
            <Box sx={{ cursor: 'pointer' }}>
              <Avatar
                name={creatorImage.firstName + ' ' + creatorImage.lastName}
                src={creatorImage.imageURL}
                size="25px"
                round={true}
                color="#AAAAAA"
              />
            </Box>
          )}
        </Tooltip>
      ))}
    </Stack>
  );
};
